module.exports = __webpack_public_path__ + "img/buy_normal_en.f374f7ab.png";